import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Annonce} from "../../models/annonce";
import {Observable} from "rxjs";
import {AnnonceService} from "../../services/annonce.service";
import {Logement} from "../../models/logement";
import {LogementService} from "../../services/logement.service";
import { gridToBreakpoints } from '../../swiper.config';

@Component({
    selector: 'app-offre-partenaire-card',
    templateUrl: './offre-partenaire-card.component.html',
    styleUrls: ['./offre-partenaire-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OffrePartenaireCardComponent implements OnInit {
  annonces$: Observable<Annonce[]>;
  annoncesFiltered: Annonce[] = [];

  carouselBreakpoints = gridToBreakpoints({ xs: 2.6, sm: 4.1, md: 1.7, lg: 2.7 });

  public logementCourant$: Observable<Logement>;

  constructor(
    private annonceService: AnnonceService,
    private logementService: LogementService
  ) {
  }

  ngOnInit(): void {
    this.annonces$ = this.annonceService.load();
    this.annonces$.subscribe((annonces) => {
      this.annoncesFiltered = annonces.filter((annonce) => annonce.logo?.url != null);
    });
    this.logementCourant$ = this.logementService.logementCourant;
  }

  showAnnouncements(logement) {
    if (logement?.societe?.partner?.showAnnouncements === false) {
      return logement?.societe?.partner?.showAnnouncements
    }

    return true
  }
}
